/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 02.08.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {OpenMessage} from '../../../actions/common/actions-common';
import {HideAdultContent, ShowAdultContent} from '../../../actions/parental/actions-parental';

import Translate from '../../../components/Translate';

class ParentalControlTab extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  _changeAdultContentState = () => {

    this.props.OpenMessage({
      type: 'pin',
      actionOnSubmit: this.props.state.hide_adult_content ? this.props.ShowAdultContent : this.props.HideAdultContent,
      actionState: {
        parental: {
          inProgress: true,
          isError: true,
          isSuccess: true,
          errorMsg: true,
          isReloadNeeded: true,
        }
      }
    });
  }

  _changePin = () => {

    this.props.OpenMessage({
      type: 'pin-change',
    });
  }

  render() {

    return (<div>
      <div className="settings-col">
        <label htmlFor="tumbler"> <Translate content="settings.tabs.parental_control.description" /> </label>
        <div className="tumbler" id="tumbler">
          <input type="checkbox" name="tumbler" id="tumbler1" checked={!this.props.state.hide_adult_content} onChange={()=>{}} onClick={this._changeAdultContentState} />
          <label htmlFor="tumbler1">
            <span> <Translate content="settings.tabs.parental_control.on" /> </span>
            <span> <Translate content="settings.tabs.parental_control.off" /> </span>
          </label>
        </div>
      </div>
      <div className="settings-col relative">
        <a className="btn-dark authorization pointer" onClick={this._changePin}>Change Pin</a>
      </div>
    </div>);
  }

}

ParentalControlTab.propTypes = {
  state: PropTypes.shape({
    channels: PropTypes.array,
    hide_adult_content: PropTypes.bool,
    lists: PropTypes.array,
    state: PropTypes.bool,
    actionState: PropTypes.shape({
      inProgress: PropTypes.bool,
      isSuccess: PropTypes.bool,
      isError: PropTypes.bool,
      errorMsg: PropTypes.string
    })
  })
};

const mapStateToProps = ({parental: {state, inProgress, isError, isSuccess, errorMsg}}) => {
  return {state, actionState: {inProgress, isError, isSuccess, errorMsg}}
};

const mapDispatchToProps = (dispatch) => {

  return bindActionCreators({OpenMessage, HideAdultContent, ShowAdultContent}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ParentalControlTab);



// WEBPACK FOOTER //
// ./src/containers/Settings/Tabs/parental-control.js